import { render } from "./VRadio.vue?vue&type=template&id=746d5298&scoped=true"
import script from "./VRadio.vue?vue&type=script&lang=js"
export * from "./VRadio.vue?vue&type=script&lang=js"

import "./VRadio.vue?vue&type=style&index=0&id=746d5298&scoped=true&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746d5298"]])

export default __exports__